// Dashboard module. Composable surface for the host.
//
// Only `(dashboard …)` is an engine top-level op (registered in
// `opMeta`); compose it via `createOpTable([...builtins, ...dashboardOps])`
// exactly like `providerOps` / `transformOps`. Tiles and
// sub-forms are NOT here — they live in `dashboardMeta` and dispatch
// hierarchically through `(dashboard …)` (see dispatch.ts). The doc
// walker reaches every tile/sub-form scope transitively via the
// `childScopes` graph rooted at `dashboard`.

import { dashboard, tileScope } from './dashboard.ts';

/** Top-level dashboard ops — compose into the engine op table. */
export const dashboardOps = [dashboard] as const;

export { cartesianChildScope, tableChildScope } from './sub-forms.ts';
// `DashboardSpec` is canonically exported from `#core/lib/expr/value.ts`
// (the Value-union home); only the tile-shape types live here.
export type { CartesianSpec, MarkdownSpec, MetricSpec, TableSpec, TileSpec } from './value.ts';
export { TILE_KIND_LABELS } from './value.ts';
// Scopes re-exported for the doc walker / tests. `tileScope`'s ops
// declare `childScopes` reaching `cartesianChildScope` /
// `tableChildScope`, so a doc root over `dashboard` discovers them all.
export { tileScope };
